module.exports = __webpack_public_path__ + "static/media/IfYouWantToChangeTheWorld.eff12def.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/IfYouWantToChangeTheWorld/IfYouWantToChangeTheWorld.mp4
// module id = 387
// module chunks = 0